module.exports = __webpack_public_path__ + "172d656bf21319ac862bd6ed818afdab.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/gs.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/gs.svg
// module chunks = 0